import axiosInstance from "./axiosConfig"

export const addColumnSetting = async (data) => {
   return await axiosInstance.post('column_settings/toggle', data)
}
export const getColumnSetting = async (data) => {
   return await axiosInstance.get(`column_settings/column_names?section_name=${data}`)
}
